// src/data/intensivePrayer2.js
// Pre-Marriage Intensive - Short Prayer Points for Modules 1-10
// 7 Concise Prayer Points per Module with Scripture Foundation

export const INTENSIVE_PRAYER_2 = {
  // ============================================================
  // MODULE 1: KINGDOM MARRIAGE – DESIGN & PERSPECTIVE
  // ============================================================
  1: {
    moduleNumber: 1,
    moduleName: "Kingdom Marriage Perspective",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, align our understanding of marriage with Your eternal design.",
        scripture: "Genesis 2:24",
        scriptureText: "Therefore a man shall leave his father and mother and be joined to his wife, and they shall become one flesh."
      },
      {
        number: 2,
        prayer: "Lord, uproot every cultural mindset conflicting with Kingdom marriage principles.",
        scripture: "Romans 12:2",
        scriptureText: "And do not be conformed to this world, but be transformed by the renewing of your mind…"
      },
      {
        number: 3,
        prayer: "Father, establish our marriage foundation on covenant, not convenience.",
        scripture: "Matthew 19:6",
        scriptureText: "Therefore what God has joined together, let not man separate."
      },
      {
        number: 4,
        prayer: "Lord, deliver us from emotional decisions that undermine lifelong commitment.",
        scripture: "Jeremiah 17:9",
        scriptureText: "The heart is deceitful above all things, and desperately wicked; who can know it?"
      },
      {
        number: 5,
        prayer: "Father, grant us wisdom to embrace marriage as divine assignment.",
        scripture: "Proverbs 19:21",
        scriptureText: "There are many plans in a man's heart, nevertheless the Lord's counsel—that will stand."
      },
      {
        number: 6,
        prayer: "Lord, silence every voice competing against Your original marriage blueprint.",
        scripture: "Isaiah 55:8",
        scriptureText: "For My thoughts are not your thoughts, nor are your ways My ways, says the Lord."
      },
      {
        number: 7,
        prayer: "Father, let our marriages reflect Christ and the Church fully.",
        scripture: "Ephesians 5:32",
        scriptureText: "This is a great mystery, but I speak concerning Christ and the church."
      }
    ]
  },

  // ============================================================
  // MODULE 2: INTIMACY THAT SUSTAINS MARRIAGE
  // ============================================================
  2: {
    moduleNumber: 2,
    moduleName: "Intimacy That Sustains Marriage",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, build deep emotional intimacy rooted in trust and safety.",
        scripture: "Song of Solomon 4:7",
        scriptureText: "You are all fair, my love, and there is no spot in you."
      },
      {
        number: 2,
        prayer: "Lord, teach us to pursue intimacy intentionally, not accidentally.",
        scripture: "Amos 3:3",
        scriptureText: "Can two walk together, unless they are agreed?"
      },
      {
        number: 3,
        prayer: "Father, heal every fear preventing honest emotional vulnerability.",
        scripture: "1 John 4:18",
        scriptureText: "There is no fear in love; but perfect love casts out fear."
      },
      {
        number: 4,
        prayer: "Lord, remove emotional distance and restore closeness in our relationships.",
        scripture: "Genesis 2:25",
        scriptureText: "And they were both naked, the man and his wife, and were not ashamed."
      },
      {
        number: 5,
        prayer: "Father, help us nurture intimacy beyond physical attraction.",
        scripture: "Proverbs 5:18",
        scriptureText: "Let your fountain be blessed, and rejoice with the wife of your youth."
      },
      {
        number: 6,
        prayer: "Lord, grant grace to manage emotions without damaging connection.",
        scripture: "Proverbs 16:32",
        scriptureText: "He who is slow to anger is better than the mighty."
      },
      {
        number: 7,
        prayer: "Father, let intimacy in our marriages grow stronger with time.",
        scripture: "Ecclesiastes 4:12",
        scriptureText: "And a threefold cord is not quickly broken."
      }
    ]
  },

  // ============================================================
  // MODULE 3: COMMUNICATION & CONFLICT MASTERY
  // ============================================================
  3: {
    moduleNumber: 3,
    moduleName: "Communication & Conflict Mastery",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, give us wisdom to speak life during moments of conflict.",
        scripture: "Proverbs 18:21",
        scriptureText: "Death and life are in the power of the tongue."
      },
      {
        number: 2,
        prayer: "Lord, help us listen with humility before responding in disagreements.",
        scripture: "James 1:19",
        scriptureText: "Let every man be swift to hear, slow to speak, slow to wrath."
      },
      {
        number: 3,
        prayer: "Father, uproot pride that fuels destructive arguments in marriage.",
        scripture: "Proverbs 13:10",
        scriptureText: "By pride comes nothing but strife."
      },
      {
        number: 4,
        prayer: "Lord, teach us to resolve conflicts promptly and peacefully.",
        scripture: "Ephesians 4:26",
        scriptureText: "Be angry, and do not sin: do not let the sun go down on your wrath."
      },
      {
        number: 5,
        prayer: "Father, establish a culture of respectful communication in our homes.",
        scripture: "Colossians 4:6",
        scriptureText: "Let your speech always be with grace, seasoned with salt."
      },
      {
        number: 6,
        prayer: "Lord, silence every spirit of escalation and emotional violence.",
        scripture: "Proverbs 15:1",
        scriptureText: "A soft answer turns away wrath."
      },
      {
        number: 7,
        prayer: "Father, make our words instruments of healing and reconciliation.",
        scripture: "Proverbs 12:18",
        scriptureText: "The tongue of the wise promotes health."
      }
    ]
  },

  // ============================================================
  // MODULE 4: TRUST, TRANSPARENCY & ACCOUNTABILITY
  // ============================================================
  4: {
    moduleNumber: 4,
    moduleName: "Trust, Transparency & Accountability",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, build unshakeable trust through consistent godly character.",
        scripture: "Luke 16:10",
        scriptureText: "He who is faithful in what is least is faithful also in much."
      },
      {
        number: 2,
        prayer: "Lord, uproot every form of secrecy damaging marital trust.",
        scripture: "Ephesians 4:25",
        scriptureText: "Therefore, putting away lying, let each one of you speak truth…"
      },
      {
        number: 3,
        prayer: "Father, establish transparency as a lifestyle in our marriages.",
        scripture: "2 Corinthians 8:21",
        scriptureText: "Providing honorable things, not only in the sight of the Lord, but also in the sight of men."
      },
      {
        number: 4,
        prayer: "Lord, surround our marriages with godly accountability structures.",
        scripture: "Proverbs 11:14",
        scriptureText: "In the multitude of counselors there is safety."
      },
      {
        number: 5,
        prayer: "Father, heal wounds caused by past betrayals and broken trust.",
        scripture: "Psalm 147:3",
        scriptureText: "He heals the brokenhearted and binds up their wounds."
      },
      {
        number: 6,
        prayer: "Lord, guard our hearts from every form of emotional infidelity.",
        scripture: "Proverbs 4:23",
        scriptureText: "Keep your heart with all diligence, for out of it spring the issues of life."
      },
      {
        number: 7,
        prayer: "Father, make our marriages safe places of truth and integrity.",
        scripture: "Psalm 15:2",
        scriptureText: "He who walks uprightly, and works righteousness, and speaks the truth in his heart."
      }
    ]
  },

  // ============================================================
  // MODULE 5: EXPECTATIONS, ROLES & GENDER NEEDS
  // ============================================================
  5: {
    moduleNumber: 5,
    moduleName: "Expectations, Roles & Gender Needs",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, align our expectations with Your divine order for marriage.",
        scripture: "Ephesians 5:33",
        scriptureText: "Let each one of you in particular so love his own wife… and let the wife see that she respects her husband."
      },
      {
        number: 2,
        prayer: "Lord, teach us to love our spouse according to their needs.",
        scripture: "Philippians 2:4",
        scriptureText: "Let each of you look out not only for his own interests, but also for the interests of others."
      },
      {
        number: 3,
        prayer: "Father, uproot every selfish demand disguised as marital expectation.",
        scripture: "1 Corinthians 13:5",
        scriptureText: "Love does not seek its own."
      },
      {
        number: 4,
        prayer: "Lord, help husbands lead through sacrifice, not domination.",
        scripture: "Ephesians 5:25",
        scriptureText: "Husbands, love your wives, just as Christ also loved the church and gave Himself for her."
      },
      {
        number: 5,
        prayer: "Father, empower wives to honor and respect with understanding.",
        scripture: "1 Peter 3:1",
        scriptureText: "Wives, likewise, be submissive to your own husbands…"
      },
      {
        number: 6,
        prayer: "Lord, remove competition and establish partnership in our marriages.",
        scripture: "1 Corinthians 11:11",
        scriptureText: "Nevertheless, neither is man independent of woman, nor woman independent of man, in the Lord."
      },
      {
        number: 7,
        prayer: "Father, let mutual honor govern every role in marriage.",
        scripture: "Romans 12:10",
        scriptureText: "Be kindly affectionate to one another with brotherly love, in honor giving preference to one another."
      }
    ]
  },

  // ============================================================
  // MODULE 6: READINESS, RED FLAGS & PREMARITAL CHECKPOINTS
  // ============================================================
  6: {
    moduleNumber: 6,
    moduleName: "Readiness, Red Flags & Checkpoints",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, grant discernment to recognize red flags early.",
        scripture: "Proverbs 22:3",
        scriptureText: "A prudent man foresees evil and hides himself."
      },
      {
        number: 2,
        prayer: "Lord, deliver us from pressure-driven marital decisions.",
        scripture: "Psalm 127:1",
        scriptureText: "Unless the Lord builds the house, they labor in vain who build it."
      },
      {
        number: 3,
        prayer: "Father, build emotional maturity before covenant commitment.",
        scripture: "Luke 14:28",
        scriptureText: "For which of you, intending to build a tower, does not sit down first and count the cost?"
      },
      {
        number: 4,
        prayer: "Lord, remove fear of waiting for Your perfect timing.",
        scripture: "Isaiah 40:31",
        scriptureText: "But those who wait on the Lord shall renew their strength."
      },
      {
        number: 5,
        prayer: "Father, expose hidden character issues before marriage.",
        scripture: "Luke 8:17",
        scriptureText: "For nothing is secret that will not be revealed."
      },
      {
        number: 6,
        prayer: "Lord, strengthen our resolve to obey wisdom over emotions.",
        scripture: "Proverbs 3:5",
        scriptureText: "Trust in the Lord with all your heart, and lean not on your own understanding."
      },
      {
        number: 7,
        prayer: "Father, let clarity, not confusion, govern marital decisions.",
        scripture: "1 Corinthians 14:33",
        scriptureText: "For God is not the author of confusion but of peace."
      }
    ]
  },

  // ============================================================
  // MODULE 7: PURPOSE, CALLING & KINGDOM PARTNERSHIP
  // ============================================================
  7: {
    moduleNumber: 7,
    moduleName: "Purpose, Calling & Kingdom Partnership",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, reveal Your purpose for our marriage clearly.",
        scripture: "Ephesians 2:10",
        scriptureText: "For we are His workmanship, created in Christ Jesus for good works."
      },
      {
        number: 2,
        prayer: "Lord, align our individual callings into one Kingdom mission.",
        scripture: "Ecclesiastes 4:9",
        scriptureText: "Two are better than one, because they have a good reward for their labor."
      },
      {
        number: 3,
        prayer: "Father, uproot self-centered ambition from our marriages.",
        scripture: "James 3:16",
        scriptureText: "For where envy and self-seeking exist, confusion and every evil thing are there."
      },
      {
        number: 4,
        prayer: "Lord, help us serve You together with unity and joy.",
        scripture: "Joshua 24:15",
        scriptureText: "As for me and my house, we will serve the Lord."
      },
      {
        number: 5,
        prayer: "Father, establish our marriage as a platform for Kingdom impact.",
        scripture: "Matthew 6:33",
        scriptureText: "But seek first the kingdom of God and His righteousness…"
      },
      {
        number: 6,
        prayer: "Lord, prevent our marriage from drifting into purposeless routine.",
        scripture: "Proverbs 29:18",
        scriptureText: "Where there is no vision, the people perish."
      },
      {
        number: 7,
        prayer: "Father, let our union glorify You in every season.",
        scripture: "1 Corinthians 10:31",
        scriptureText: "Whatever you do, do all to the glory of God."
      }
    ]
  },

  // ============================================================
  // MODULE 8: SEXUAL INTEGRITY, DISCIPLINE & FIDELITY
  // ============================================================
  8: {
    moduleNumber: 8,
    moduleName: "Sexual Integrity, Discipline & Fidelity",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, empower us to honor You with our bodies.",
        scripture: "1 Corinthians 6:20",
        scriptureText: "For you were bought at a price; therefore glorify God in your body."
      },
      {
        number: 2,
        prayer: "Lord, build sexual discipline before marriage covenant.",
        scripture: "1 Thessalonians 4:3",
        scriptureText: "For this is the will of God, your sanctification: that you should abstain from sexual immorality."
      },
      {
        number: 3,
        prayer: "Father, deliver us from lust-driven decisions.",
        scripture: "Matthew 5:28",
        scriptureText: "Whoever looks at a woman to lust for her has already committed adultery…"
      },
      {
        number: 4,
        prayer: "Lord, establish boundaries that protect marital purity.",
        scripture: "Proverbs 4:23",
        scriptureText: "Keep your heart with all diligence…"
      },
      {
        number: 5,
        prayer: "Father, guard our marriages from infidelity and compromise.",
        scripture: "Hebrews 13:4",
        scriptureText: "Marriage is honorable among all, and the bed undefiled."
      },
      {
        number: 6,
        prayer: "Lord, restore holiness where sexual patterns were broken.",
        scripture: "Psalm 51:10",
        scriptureText: "Create in me a clean heart, O God."
      },
      {
        number: 7,
        prayer: "Father, make faithfulness our lifelong testimony.",
        scripture: "Proverbs 20:6",
        scriptureText: "But who can find a faithful man?"
      }
    ]
  },

  // ============================================================
  // MODULE 9: ENDURANCE, FORGIVENESS & MARITAL RESILIENCE
  // ============================================================
  9: {
    moduleNumber: 9,
    moduleName: "Endurance, Forgiveness & Resilience",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, strengthen us to endure challenging seasons together.",
        scripture: "James 1:12",
        scriptureText: "Blessed is the man who endures temptation…"
      },
      {
        number: 2,
        prayer: "Lord, give us grace to forgive without keeping records.",
        scripture: "1 Corinthians 13:5",
        scriptureText: "Love… keeps no record of wrongs."
      },
      {
        number: 3,
        prayer: "Father, uproot bitterness before it damages our covenant.",
        scripture: "Hebrews 12:15",
        scriptureText: "Lest any root of bitterness springing up cause trouble."
      },
      {
        number: 4,
        prayer: "Lord, help us grow stronger through trials, not divided.",
        scripture: "Romans 5:3–4",
        scriptureText: "Tribulation produces perseverance; and perseverance, character."
      },
      {
        number: 5,
        prayer: "Father, teach us patience during delayed answers and seasons.",
        scripture: "Psalm 27:14",
        scriptureText: "Wait on the Lord; be of good courage."
      },
      {
        number: 6,
        prayer: "Lord, restore hope where disappointment has crept in.",
        scripture: "Proverbs 13:12",
        scriptureText: "Hope deferred makes the heart sick."
      },
      {
        number: 7,
        prayer: "Father, establish resilience as a hallmark of our marriage.",
        scripture: "Ecclesiastes 7:8",
        scriptureText: "The end of a thing is better than its beginning."
      }
    ]
  },

  // ============================================================
  // MODULE 10: BOUNDARIES, COMMUNITY & SUSTAINABILITY
  // ============================================================
  10: {
    moduleNumber: 10,
    moduleName: "Boundaries, Community & Sustainability",
    factorName: "Short Prayer Points",
    totalPrayers: 7,
    prayers: [
      {
        number: 1,
        prayer: "Father, establish healthy boundaries that protect our marriage.",
        scripture: "Genesis 2:24",
        scriptureText: "Therefore a man shall leave his father and mother…"
      },
      {
        number: 2,
        prayer: "Lord, help us prioritize marriage over every competing demand.",
        scripture: "Ecclesiastes 9:9",
        scriptureText: "Live joyfully with the wife whom you love…"
      },
      {
        number: 3,
        prayer: "Father, connect our marriages to godly community and counsel.",
        scripture: "Hebrews 10:24–25",
        scriptureText: "Not forsaking the assembling of ourselves together…"
      },
      {
        number: 4,
        prayer: "Lord, guard our marriages from isolation and secrecy.",
        scripture: "Proverbs 18:1",
        scriptureText: "A man who isolates himself seeks his own desire."
      },
      {
        number: 5,
        prayer: "Father, help us seek help early, not after damage.",
        scripture: "Proverbs 11:14",
        scriptureText: "In the multitude of counselors there is safety."
      },
      {
        number: 6,
        prayer: "Lord, protect our marriages from external interference.",
        scripture: "Isaiah 54:17",
        scriptureText: "No weapon formed against you shall prosper."
      },
      {
        number: 7,
        prayer: "Father, let our marriages finish strong and faithful.",
        scripture: "Matthew 24:13",
        scriptureText: "He who endures to the end shall be saved."
      }
    ]
  }
};

export default INTENSIVE_PRAYER_2;
